<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		index
		paging
		:columns="columns"
		:stripe="false"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		@changedPage="changedPage"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'altrNo'">
				<span class="highlighted" @click="() => rowClick(slotProps.row)">{{ slotProps.row.altrNo }}</span>
			</template>
		</template>
		<template v-slot:actionsLeft>
			<sf-button
				v-if="isButton_(scrId, 'CC') && ((isPqyGuest && searchParams.cofCd) || isPqyStaff)"
				line
				icon="square-plue"
				:onClick="openPopup"
			>
				{{ getMessage_('QWCC001083') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { BASE_URL } from '@/constants';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
/*엑셀다운로드 시작*/

export default {
	props: { scrId: { type: String, default: '' } },
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return this.getColumns_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		saveAction() {
			this.setState_({ key: 'isSaved', value: true });
		},
		rowClick(row) {
			this.$emit('openPopup', row);
		},
		openPopup() {
			this.$emit('openPopup');
		},
		excelFunc() {
			const queryStr = this.$sf_objectToQueryString({
				strDt: this.searchParams.strDt,
				endDt: this.searchParams.endDt,
				partNo: this.searchParams.partNo,
				altrNo: this.searchParams.altrNo,
				cofCd: this.searchParams.cofCd ? this.searchParams.cofCd : this.searchParams.cofNm,
				pgsStEmCd: this.searchParams.pgsStEmCd
			});
			const url = `${BASE_URL}/pqy/pcku/eo4mApcn/v1/excels${queryStr}`;
			this.$sf_xlsxDown({ url, columns: this.columns }).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	}
};
</script>
